import React, { Component } from 'react';

import { Sector, PieChart, Pie, ResponsiveContainer } from 'recharts';

import {LIGHT_COLOUR, MIDDLE_COLOUR, HEAVY_COLOUR, EMPTY_COLOUR } from '../../constants';

// CSS 
import './TotalsPieChart.css';

function getFirstNonZeroIndex(data) {
    if (!data || data.length === 0) return 0;
    const index = data.findIndex(item => item.value > 0);
    return index === -1 ? 0 : index;
}

class TotalsPieChart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeIndex: getFirstNonZeroIndex(props.data), 
            data: null, 
            colors: this.getColorsForCommodity(props.commodityType),
            commodityType: props.commodityType
        };
        
        this.onPieEnter = this.onPieEnter.bind(this);
    }
    
    onPieEnter(data, index) {
        this.setState({
            activeIndex: index,
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                activeIndex: getFirstNonZeroIndex(this.props.data)
            });
        }
    }

    getColorsForCommodity(commodityType) {
        switch (commodityType) {
            case 'light':
                return [LIGHT_COLOUR, LIGHT_COLOUR];
            case 'middle':
                return [MIDDLE_COLOUR, MIDDLE_COLOUR];
            case 'heavy':
                return [HEAVY_COLOUR, HEAVY_COLOUR];
            default:
                return [EMPTY_COLOUR, EMPTY_COLOUR];
        }
    }

    render() {

        if (this.props.data == null) {
            return null;
        }

        const data = this.props.data;

        const renderShape = (props, index) => {
            const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, payload, percent, value } = props;
            const fill = this.state.colors[index % 2];

            if (index === this.state.activeIndex) {
                return (
                    <g>
                        <text x={cx} y={cy + 125} dy={8} textAnchor="middle" fill={fill}>
                            {payload.name}
                        </text>
                        <text x={cx} y={cy - 15} dy={7} textAnchor="middle" fill="#fff">{`Lvl ${value}`}</text>
                        <text x={cx} y={cy} dy={8} textAnchor="middle" fill="#999">
                            {`(Rate ${(percent * 100).toFixed(2)}%)`}
                        </text>
                        <Sector
                            cx={cx}
                            cy={cy}
                            innerRadius={innerRadius + 2}
                            outerRadius={outerRadius - 1}
                            startAngle={startAngle}
                            endAngle={endAngle}
                            fill={fill}
                            strokeWidth={2}
                            stroke="black"
                        />
                        <Sector
                            cx={cx}
                            cy={cy}
                            startAngle={startAngle}
                            endAngle={endAngle}
                            innerRadius={innerRadius - 6}
                            outerRadius={innerRadius - 2}
                            fill={fill}
                            strokeWidth={2}
                            stroke="black"
                        />
                    </g>
                );
            }

            return (
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                    strokeWidth={2}
                    stroke="black"
                />
            );
        };

        if (this.state.colors == null) {
            return null;
        }

        return (
            <div>
                <ResponsiveContainer height={260} className="center">
                    <PieChart>
                        <Pie
                            shape={renderShape}
                            data={data}
                            cx={170}
                            cy={115}
                            labelLine={true}
                            innerRadius={80}
                            outerRadius={115}
                            onMouseEnter={this.onPieEnter}
                            dataKey="value"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    }

}

export default TotalsPieChart;